import React from "react";

// Liste de faits « libellé / valeur » (dl) : synthèse d'identité en en-tête.
// facts : [{ id, label, value, mono, copyValue, render, truncate }]
// `truncate` : valeur sur une ligne avec ellipse (le libellé complet reste
// lisible au survol et via le bouton copier).
// `onCopy(value, label)` est appelé quand l'utilisateur copie un fait.
const FactList = ({ facts = [], onCopy = null, emptyLabel = "—", className = "" }) => (
  <dl className={`fact-list ${className}`.trim()}>
    {facts.map((fact) => {
      const isEmpty = fact.value === undefined || fact.value === null || fact.value === "";
      return (
        <div
          key={fact.id}
          className={`fact${fact.mono ? " fact--mono" : ""}${fact.truncate ? " fact--truncate" : ""}`}
        >
          <dt>{fact.label}</dt>
          <dd>
            {fact.render ? (
              fact.render(fact.value)
            ) : isEmpty ? (
              <span className="fact__empty">{emptyLabel}</span>
            ) : (
              <span
                className="fact__value"
                title={fact.truncate && typeof fact.value === "string" ? fact.value : undefined}
              >
                {fact.value}
              </span>
            )}
            {fact.copyValue && onCopy && (
              <button
                type="button"
                className="fact__copy"
                onClick={() => onCopy(fact.copyValue, fact.label)}
                aria-label={`Copier ${fact.label}`}
                title="Copier dans le presse-papier"
              >
                <i className="fa fa-copy" aria-hidden="true" />
              </button>
            )}
          </dd>
        </div>
      );
    })}
  </dl>
);

export default FactList;
